import type { ErrorResponse } from './types/error';

export function isErrorResponse(response: any): response is ErrorResponse {
  return !!(response as ErrorResponse).response.data?.error;
}
